module.exports = __webpack_public_path__ + "ColabMed.5c217dc73663244fa549.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/assets/font/colaborate/ColabMed.woff
// module id = ../../../../../src/assets/font/colaborate/ColabMed.woff
// module chunks = 2